import React from 'react';
import { Eye, LogOut } from 'lucide-react';

/**
 * Persistent banner shown across the entire app while an admin is impersonating
 * another user. Always-visible reminder + one-click exit.
 */
const ImpersonationBanner = ({ user }) => {
  if (!user?.is_impersonation) return null;

  const handleExit = () => {
    if (typeof window.__stopImpersonation === 'function') {
      window.__stopImpersonation();
    }
  };

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[80] bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg"
      data-testid="impersonation-banner"
      role="status"
      aria-live="polite"
    >
      <div className="px-3 sm:px-5 py-2 flex items-center justify-between gap-2 max-w-7xl mx-auto">
        <div className="flex items-center gap-2 min-w-0 text-xs sm:text-sm">
          <Eye className="w-4 h-4 flex-shrink-0" />
          <p className="truncate">
            <span className="font-medium">{user.impersonated_by || 'Admin'}</span>
            <span className="opacity-90"> previewing as </span>
            <span className="font-semibold">{user.username}</span>
            <span className="opacity-80 hidden sm:inline"> ({user.role})</span>
          </p>
        </div>
        <button
          onClick={handleExit}
          data-testid="impersonation-exit"
          className="flex items-center gap-1 px-2.5 py-1 bg-white/20 hover:bg-white/30 rounded text-xs font-medium border border-white/30 flex-shrink-0"
        >
          <LogOut className="w-3.5 h-3.5" />
          <span className="hidden sm:inline">Exit Preview</span>
          <span className="sm:hidden">Exit</span>
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
